module.exports = __webpack_public_path__ + "img/hat_female_cap_mask.c2d7b672.png";